<template lang="html">
  <div class="report-calls">
    <div class="card">
      <div class="card-header">
        <h3 class="text-nowrap">Histórico de Chamadas</h3>
        <div class="w-100">
          <font
            class="float-right"
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
      <div class="card-body">
        <div
          v-if="error"
          class="alert alert-danger"
          role="alert">
          <span v-html="error.message" />
        </div>
        <div class="row w-100 d-flex no-whitespace">
          <div class="col-4">
            <div
              id="picker-container"
              class="input-group input-daterange filter-date">
              <input
                id='startedAt'
                type="text"
                class="form-control date"
                :value="startedAtToString"
                readonly>
              <div class="input-group-prepend">
                <span class="input-group-text">até</span>
              </div>
              <input
                id='endedAt'
                type="text"
                class="form-control date"
                :value="endedAtToString"
                readonly>
              <div class="input-group-append">
                <span
                  class="input-group-text cursor"
                  :title="filterOrderTitle"
                  @click="changeReportDirection">
                  <i
                    class="ik"
                    :class="filterOrderButton" />
                </span>
              </div>
              <a
                href="#"
                class="btn btn-primary btn-search"
                @click.prevent="getCdrsByDate">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  width="16"
                  height="16"
                  title="Pesquisar">
                  <path
                    fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
          <div class="col-1">
            <img
              src="/static/images/loading.gif"
              width="32"
              height="32"
              alt="Carregando dados, aguarde..."
              title="Carregando dados, aguarde..."
              v-show="loading">
          </div>
          <div class="col-4">
            <div class="input-group filter-all">
              <input
                type="text"
                class="form-control"
                placeholder="Buscar em todos campos"
                aria-label="Buscar em todos campos"
                v-model="filter">
              <div class="input-group-append">
                <button
                  :disabled="!filter"
                  @click="filter = ''"
                  class="input-group-text">Limpar</button>
              </div>
            </div>
          </div>
          <div class="col-1">
            <a
              href="#"
              class="btn btn-outline-primary download-excel"
              @click.prevent="csvExport">
              <img
                src="/static/images/icons/download.png"
                width="16"
                height="16"
                title="EXCEL">
            </a>
          </div>
          <div class="col-2">
            <div class="input-group">
              <div class="input-group justify-content-end per-page">
                <div class="input-group-prepend">
                  <button
                    disabled
                    class="input-group-text">por página</button>
                </div>
                <select
                  class="form-control custom-select perPage"
                  id="perPage"
                  v-model="perPage">
                  <option
                    v-for="option in pageOptions"
                    :key="option"
                    :value="option">
                    {{ option }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="card-table text-left">
          <b-table
            class="table"
            show-empty
            striped
            hover
            small
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered">

            <template
              slot="record_url"
              slot-scope="row">
              <div v-if="hasRecordUrl(row.item)">
                <button
                  class="btn btn-sm"
                  href="#"
                  @click.prevent="download(row.item.record_url)">
                  <img
                    src="/static/images/icons/play-circle.png"
                    width="16"
                    height="16">
                </button>
              </div>
            </template>

            <template
              slot="metadata"
              slot-scope="row">
              <div
                class="text-center"
                title="Exibir metadados"
                v-if="hasMetadata(row.item)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="cursor"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  width="20"
                  height="20"
                  @click="openShowMetadata(row.item)">
                  <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z" />
                  <path
                    fillRule="evenodd"
                    d="M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z"
                    clipRule="evenodd" />
                </svg>
              </div>
            </template>
          </b-table>
        </div>
        <b-pagination
          align="center"
          class="pagination"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          :limit="10" />
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="showMetadata"
      ref="showMetadata"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h1 class="text-center">Metadados</h1>
            <div
              class="text-center"
              v-html="showMetadataText" />
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal">Fechar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialReportCalls"
      ref="tutorialReportCalls"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Relatório de Chamadas</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/rQGKsi1LVrk?start=141"
              title="Tutorial Relatório de Chamadas"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import {parsePhoneNumberFromString} from 'libphonenumber-js'
import { HANGUPCAUSES_MAPPER } from '../../services/cdr-data-source'
import DatepickerLanguages from './datepickerLanguages'

export default {
  name: 'ReportsCdrs',
  data () {
    return {
      loading: false,
      perPage: 10,
      pageOptions: [10, 25, 50],
      currentPage: 1,
      totalRows: 1,
      filter: null,
      startedAt: new Date(new Date().setHours(0, 0, 0, 0)),
      startedAtNew: new Date(new Date().setHours(0, 0, 0, 0)),
      endedAt: new Date(new Date().setHours(0, 0, 0, 0)),
      endedAtNew: new Date(new Date().setHours(0, 0, 0, 0)),
      filterOrder: 'desc',
      filterOrderButton: 'ik-arrow-down',
      filterOrderTitle: 'Ordem Decrescente',
      error: null,
      fields: {
        first_name: {
          label: 'Atendente',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            let completeName = value || ''
            if (item.last_name) completeName += ` ${item.last_name}`
            return completeName
          }
        },
        from: {
          label: 'Ramal',
          sortable: true
        },
        to: {
          label: 'Número discado',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return this.parsePhoneNumberAsFormatNational(String(value))
          }
        },
        started_at: {
          label: 'Iniciou às',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return this.parseDate(value)
          }
        },
        ended_at: {
          label: 'Finalizou às',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return this.parseDate(value)
          }
        },
        duration: {
          label: 'Duração',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return this.secondsToTimeParser(value)
          }
        },
        minute_price: {
          label: 'Tarifa',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return value ? `R$ ${value}` : ''
          }
        },
        call_price: {
          label: 'Custo da Ligação',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return value ? `R$ ${value}` : ''
          }
        },
        hangup_cause: {
          label: 'Causa do desligamento',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return this.parseHangupCause(value)
          }
        },
        call_type: {
          label: 'Tipo',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            return value === 'outbound' ? 'Sainte' : 'Entrante'
          }
        },
        metadata: {
          label: 'Metadado',
          sortable: false,
          sortByFormatted: false,
          filterByFormatted: false
        },
        record_url: {
          label: 'Gravação',
          sortable: false
        }
      },
      items: [],
      showMetadataText: ''
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.getCdrs()
      $.fn.datepicker.dates['pt-BR'] = DatepickerLanguages['pt-BR']
      const functionToChangeDateEvent = this.changeDateEvent
      $('.input-daterange input').each(function () {
        $(this).datepicker({
          language: 'pt-BR',
          container: '#picker-container',
          autoclose: true,
          todayHighlight: true
        }).on('changeDate', functionToChangeDateEvent)
      })
    })
  },
  methods: {
    getCdrs () {
      this.loading = true
      this.items = []
      const start = `${this.startedAt.toJSON().slice(0, 11)}00:00:00Z`
      const end = `${this.endedAt.toJSON().slice(0, 11)}23:59:59Z`
      this.getCdrsFromApi(start, end)
    },
    getCdrsFromApi (start, end, page = 1) {
      this.error = null
      return loopback
        .get([
          '/calls',
          `?page=${page}`,
          '&filter[limit]=1000',
          `&filter[where][and][][started_at][gt]=${start}`,
          `&filter[where][and][][ended_at][lt]=${end}`,
          `&filter[order]=started_at ${this.filterOrder}`
        ].join(''))
        .then(cdrs => {
          if (cdrs) {
            if (cdrs.data) {
              this.items = this.items.concat(Array.from(cdrs.data))
              this.totalRows = this.items.length
            }
            if (cdrs.meta && cdrs.meta.nextPage) return this.getCdrsFromApi(start, end, cdrs.meta.nextPage)
            this.loading = false
          }
        })
        .catch((err) => {
          this.loading = false
          this.error = err
        })
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    hasRecordUrl (record) {
      if (record && record.hangup_cause === 'NORMAL_CLEARING' && record.record_url && record.record_url.length > 0) return true
      return false
    },
    hasMetadata (record) {
      if (record && record.metadata && typeof record.metadata === 'object') return true
      return false
    },
    openShowMetadata (record) {
      if (record && record.metadata && typeof record.metadata === 'object') {
        let metadataAsString = ''
        const keys = Object.keys(record.metadata)
        if (keys && keys.length > 0) {
          metadataAsString += '<table class="table table-striped table-hover table-sm"><tr><th>Chave</th><th>Valor</th></tr>'
          keys.forEach(key => {
            metadataAsString += `<tr><td>${key}</td><td>${record.metadata[key]}</td></tr>`
          })
          metadataAsString += '</table>'
        }
        this.showMetadataText = metadataAsString
      } else {
        this.showMetadataText = ''
      }
      $(this.$refs.showMetadata).modal('show')
    },
    getMetadataToCSV (metadata) {
      if (metadata && typeof metadata === 'object') {
        let metadataAsString = ''
        const keys = Object.keys(metadata)
        if (keys && keys.length > 0) {
          keys.forEach(key => {
            metadataAsString += `,${key}:${metadata[key]}`
          })
          metadataAsString = metadataAsString.slice(1)
        }
        return metadataAsString
      }
      return ''
    },
    fetchRecordUrl (record) {
      if (this.hasRecordUrl(record)) return [record.record_url]
      return []
    },
    parseDate (date) {
      if (date) return new Date(date).toLocaleString('pt-BR', { timeZone: 'UTC' })
      return ''
    },
    parseDateFromLocaleString (date) {
      if (date) {
        const dates = date.split('/')
        return new Date(Date.UTC(dates[2], dates[1], dates[0], 12, 0, 0))
      }
      return ''
    },
    secondsToTimeParser (seconds) {
      seconds = parseInt(seconds)
      let hours = parseInt(seconds / 3600)
      seconds = seconds % 3600
      let minutes = parseInt(seconds / 60)
      seconds = seconds % 60
      return `${this.twoDigitsParser(hours)}:${this.twoDigitsParser(minutes)}:${this.twoDigitsParser(seconds)}`
    },
    parseHangupCause (hangupCause) {
      return HANGUPCAUSES_MAPPER[hangupCause] || hangupCause
    },
    parsePhoneNumberAsFormatNational (number) {
      const phoneParsed = parsePhoneNumberFromString(number, 'BR')
      if (phoneParsed && phoneParsed.isValid()) return phoneParsed.formatNational()
      else return number
    },
    parsePhoneNumberAsNationalNumber (number) {
      const phoneParsed = parsePhoneNumberFromString(number, 'BR')
      if (phoneParsed && phoneParsed.isValid()) return phoneParsed.nationalNumber
      else return number
    },
    extractExtension (accountCode) {
      if (accountCode && typeof accountCode === 'string') return accountCode.split('@')[0]
      else return accountCode
    },
    csvExport () {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += [
        'ID;Atendente;Ramal;Número discado;Iniciou às;Finalizou às;Duração;Preço do minuto;Preço da chamada;Causa do desligamento;Tipo;Gravação;Metadados',
        ...this.items.map(
          item => `${
            item.id
          };${
            `${item.first_name ? item.first_name : ''} ${item.last_name ? item.last_name : ''}`
          };${
            item.from
          };${
            this.parsePhoneNumberAsNationalNumber(String(item.to))
          };${
            this.parseDate(item.started_at)
          };${
            this.parseDate(item.ended_at)
          };${
            item.duration
          };${
            item.minute_price ? item.minute_price : ''
          };${
            item.call_price ? item.call_price : ''
          };${
            this.parseHangupCause(item.hangup_cause)
          };${
            item.call_type === 'outbound' ? 'Sainte' : 'Entrante'
          };${
            item.record_url ? item.record_url : ''
          };${
            item.metadata ? this.getMetadataToCSV(item.metadata) : ''
          }`
        )
      ].join('\n').replace(/(^\[)|(\]$)/gm, '')
      const data = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', 'export.csv')
      link.click()
    },
    download (recordUrl) {
      window.open(recordUrl, 'download')
    },
    twoDigitsParser (value) {
      return `0${value}`.substr(-2)
    },
    changeDateEvent (event) {
      if (event.target.id === 'startedAt') {
        this.startedAtNew = (event.date <= this.endedAtNew) ? new Date(event.date) : this.startedAt
      } else if (event.target.id === 'endedAt') {
        this.endedAtNew = (event.date >= this.startedAtNew) ? new Date(event.date) : this.endedAt
      }
    },
    getCdrsByDate () {
      const diffInDays = Math.floor((this.endedAtNew - this.startedAtNew) / 86400000)
      if (diffInDays > 30) {
        this.error = {
          message: 'Intervalo máximo entre as datas é 30 dias'
        }
      } else {
        if (this.startedAtNew) this.startedAt = this.startedAtNew
        if (this.endedAtNew) this.endedAt = this.endedAtNew
      }
      $($('.input-daterange input')[0]).datepicker('update', this.startedAt)
      $($('.input-daterange input')[1]).datepicker('update', this.endedAt)
    },
    changeReportDirection () {
      if (this.filterOrder === 'desc') {
        this.filterOrder = 'asc'
        this.filterOrderButton = 'ik-arrow-up'
        this.filterOrderTitle = 'Ordem Crescente'
      } else {
        this.filterOrder = 'desc'
        this.filterOrderButton = 'ik-arrow-down'
        this.filterOrderTitle = 'Ordem Decrescente'
      }
      return this.getCdrs()
    },
    openTutorial () {
      $(this.$refs.tutorialReportCalls).modal('show')
    }
  },
  computed: {
    startedAtToString () {
      return this.startedAt.toLocaleDateString('pt-BR')
    },
    endedAtToString () {
      return this.endedAt.toLocaleDateString('pt-BR')
    }
  },
  watch: {
    startedAt: {
      handler: function startedAtObserver (to, from) {
        if (to && from && to.toJSON().slice(0, 10) !== from.toJSON().slice(0, 10) && !this.loading) this.getCdrs()
      },
      immediate: true
    },
    endedAt: {
      handler: function endedAtObserver (to, from) {
        if (to && from && to.toJSON().slice(0, 10) !== from.toJSON().slice(0, 10) && !this.loading) this.getCdrs()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.form-control {
  height: 15px;
}
.date {
  max-width: 120px;
  background-color: white;
}
.cursor {
  cursor: pointer;
}
.btn-search {
  height: 35px !important;
  margin-left: 10px;
}
.download-excel {
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/Calls.vue